// extracted by mini-css-extract-plugin
export default {"menu":"HambugerMenu_menu__pFK-p","rectangle":"HambugerMenu_rectangle__WM6ZL","icon":"HambugerMenu_icon__7Z2vE","fadeIn":"HambugerMenu_fadeIn__DZvlA"};